// extracted by mini-css-extract-plugin
export default {"container":"content_container__bHOI0"};